module.exports = __webpack_public_path__ + "img/logo_amministrazione_trasparente.03097675.jpg";